import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const Stepper = ({ steps, activeStep, handleActiveStep, clickable, beforeDone, testId }) => (
  <div
    data-testid={testId}
    className="jisrStepper"
  >
    {steps.map((step, index) => {
      const stepNo = index + 1
      return (
        <div
          key={`jisrStep-${index}`}
          className={classNames(
            'jisrStepper__step',
            activeStep === stepNo && 'jisrStepper__step--active',
            !clickable && 'jisrStepper__step--disabled',
            beforeDone && activeStep > stepNo && 'jisrStepper__step--done',
          )}
          onClick={() => handleActiveStep(stepNo)}
        >
          <span className="jisrStepper__step__stepno">{stepNo}</span>
          {step}
        </div>
      )
    })}
  </div>
)

Stepper.propTypes = {
  steps: PropTypes.arrayOf(String),
  activeStep: PropTypes.number,
  testId: PropTypes.string,
  handleActiveStep: PropTypes.func,
  clickable: PropTypes.bool,
  beforeDone: PropTypes.bool,
}

export default Stepper
